import State from "@/helpers/pattern/state";
import { PerfilUsuario } from "@/models/seguridad/perfilUsuario";
import { modelIsModified } from "@/helpers/vue-mc";
import PerfilUsuarioAPI from "@/services/seguridad/perfilUsuario";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

/**
 * State Pattern for perfilusuario form
 */
export default class PerfilUsuarioStates extends State {
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */

  constructor(data) {
    super(data);
  }

  /**
   * General Methods
   */
  base() {
    return {
      resetModel({ $data }) {
        $data.perfilUsuario = new PerfilUsuario();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.perfilUsuario) || $data.view.action.submit.busy || !modelIsModified($data.perfilUsuario);
      }
      , loadImage({ $data }, foto) {
        try {
          let image = new Image();

          // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
          image.setAttribute("crossorigin", "anonymous");
          image.src = foto;

          let orientation = 1;
          image.onload = () => {
            $data.croppa._onload(image, orientation);
          };
          $data.croppa.refresh();
        } catch (error) {
          console.log(error);
        }
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function () {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();
        }
      }
      , editing: {
        $constructor: function ({ $data }, { username, foto, fotoMiniatura }) {
          this.loadImage(foto);

          $data.perfilUsuario = new PerfilUsuario({
            username
            , foto: foto ? foto : "/static/img/user_thumbnail.jpg"
            , fotoMiniatura: fotoMiniatura ? fotoMiniatura : "/static/img/user_thumbnail.jpg"
          });

          this.resetValidators();
        }
        , async submit({ $data }, { username, foto, fotoMiniatura }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await PerfilUsuarioAPI.update({
              username
              , foto
              , fotoMiniatura
            });

            $data.view.action.submit.busy = false;
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/seguridad/perfilUsuario/perfilUsuario-state.js